import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
} = url;
import {
  downloadFile,
} from 'containers/App/screens/Foundation/utils/downloadFile';

const FETCH_VERIFYLIST_REQUEST = 'Foundation/pa/VERIFYLIST_REQUEST';
const FETCH_VERIFYLIST_SUCCESS = 'Foundation/pa/VERIFYLIST_SUCCESS';
const FETCH_VERIFYLIST_FAIL = 'Foundation/pa/VERIFYLIST_FAIL';

const FETCH_VERIFYLIST_SINGLE_REQUEST = 'Foundation/pa/VERIFYLIST_SINGLE_REQUEST';
const FETCH_VERIFYLIST_SINGLE_SUCCESS = 'Foundation/pa/VERIFYLIST_SINGLE_SUCCESS';
const FETCH_VERIFYLIST_SINGLE_FAIL = 'Foundation/pa/VERIFYLIST_SINGLE_FAIL';

const FETCH_VERIFYLIST_APPROVED_REQUEST = 'Foundation/pa/VERIFYLIST_APPROVED_REQUEST';
const FETCH_VERIFYLIST_APPROVED_SUCCESS = 'Foundation/pa/VERIFYLIST_APPROVED_SUCCESS';
const FETCH_VERIFYLIST_APPROVED_FAIL = 'Foundation/pa/VERIFYLIST_APPROVED_FAIL';

const GET_DOWNLOADFILE_VERIFYLIST_REQUEST = 'Foundation/pa/DOWNLOADFILE_VERIFYLIST_REQUEST';
const GET_DOWNLOADFILE_VERIFYLIST_SUCCESS = 'Foundation/pa/DOWNLOADFILE_VERIFYLIST_SUCCESS';
const GET_DOWNLOADFILE_VERIFYLIST_ERROR = 'Foundation/pa/DOWNLOADFILE_VERIFYLIST_ERROR';

const PUT_VERIFYLIST_OK_REQUEST = 'Foundation/pa/VERIFYLIST_OK_REQUEST';
const PUT_VERIFYLIST_OK_SUCCESS = 'Foundation/pa/VERIFYLIST_OK_SUCCESS';
const PUT_VERIFYLIST_OK_FAIL = 'Foundation/pa/VERIFYLIST_OK_FAIL';

const PUT_VERIFYLIST_BACK_REQUEST = 'Foundation/pa/VERIFYLIST_BACK_REQUEST';
const PUT_VERIFYLIST_BACK_SUCCESS = 'Foundation/pa/VERIFYLIST_BACK_SUCCESS';
const PUT_VERIFYLIST_BACK_FAIL = 'Foundation/pa/VERIFYLIST_BACK_FAIL';

export default function reducer(state = {
  keyword: '',
  datas: [],
  singleData: {},
  page: {},
  isListLoading: false,
  isFormLoading: false,
}, action) {
  switch (action.type) {
    case FETCH_VERIFYLIST_REQUEST:
      return Object.assign({}, state, {
        isListLoading: true,
      });
    case FETCH_VERIFYLIST_APPROVED_REQUEST:
      return Object.assign({}, state, {
        isListLoading: true,
      });
    case FETCH_VERIFYLIST_SUCCESS:
      return Object.assign({}, state, {
        isListLoading: false,
        datas: action.response.data,
        page: action.response.meta,
      });
    case FETCH_VERIFYLIST_APPROVED_SUCCESS:
      return Object.assign({}, state, {
        isListLoading: false,
        datas: action.response.data,
        page: action.response.meta,
      });
    case FETCH_VERIFYLIST_FAIL:
      return Object.assign({}, state, {
        isListLoading: false,
      });
    case FETCH_VERIFYLIST_APPROVED_FAIL:
      return Object.assign({}, state, {
        isListLoading: false,
      });
    case FETCH_VERIFYLIST_SINGLE_REQUEST:
      return Object.assign({}, state, {
        isFormLoading: true,
      });
    case FETCH_VERIFYLIST_SINGLE_SUCCESS:
      return Object.assign({}, state, {
        singleData: action.response.data,
        isFormLoading: false,
      });
    case FETCH_VERIFYLIST_SINGLE_FAIL:
      return Object.assign({}, state, {
        isFormLoading: false,
      });
    default:
      return state;
  }
}
/* 下載附件 */
export function downloadAnnouncementFile(id) {
  const downloadUrl = NEWTUBE_API_SERVER + `pa/VerifyList/${id}/File`;
  const types = [
    GET_DOWNLOADFILE_VERIFYLIST_REQUEST,
    GET_DOWNLOADFILE_VERIFYLIST_SUCCESS,
    GET_DOWNLOADFILE_VERIFYLIST_ERROR,
  ];
  return downloadFile(downloadUrl, types);
}

export function fetchInfoEmployeeList(pageNumber) {
  let pageListNumber = undefined;
  let pageSize = undefined;
  if (pageNumber) {
    pageListNumber = pageNumber.pageNumber;
    if (pageNumber.pageCount) {
      pageSize = pageNumber.pageCount;
    } else {
      pageSize = 10;
    }
  } else {
    pageSize = 10;
    pageListNumber = 1;
  }
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `pa/VerifyList?CurrentStatus=10&CurrentStatus=40&pageNumber=${pageListNumber}&pageSize=${pageSize}`,
      method: 'GET',
      types: [
        FETCH_VERIFYLIST_REQUEST,
        FETCH_VERIFYLIST_SUCCESS,
        FETCH_VERIFYLIST_FAIL,
      ],
    },
  };
}
export function fetchInfoEmployeeListApproved(pageNumber) {
  let pageApprovedNumber = undefined;
  let pageSize = undefined;
  if (pageNumber) {
    pageApprovedNumber = pageNumber.pageNumber;
    if (pageNumber.pageCount) {
      pageSize = pageNumber.pageCount;
    } else {
      pageSize = 10;
    }
  } else {
    pageSize = 10;
    pageApprovedNumber = 1;
  }
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `pa/VerifyList?CurrentStatus=99&pageNumber=${pageApprovedNumber}&pageSize=${pageSize}`,
      method: 'GET',
      types: [
        FETCH_VERIFYLIST_APPROVED_REQUEST,
        FETCH_VERIFYLIST_APPROVED_SUCCESS,
        FETCH_VERIFYLIST_APPROVED_FAIL,
      ],
    },
  };
}
export function fetchInfoEmployeeData(id) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `pa/VerifyList/${id}`,
      method: 'GET',
      types: [
        FETCH_VERIFYLIST_SINGLE_REQUEST,
        FETCH_VERIFYLIST_SINGLE_SUCCESS,
        FETCH_VERIFYLIST_SINGLE_FAIL,
      ],
    },
  };
}
export function getPassRecord(id) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `pa/VerifyList/${id}/OK`,
      types: [
        PUT_VERIFYLIST_OK_REQUEST,
        PUT_VERIFYLIST_OK_SUCCESS,
        PUT_VERIFYLIST_OK_FAIL,
      ],
      method: 'PUT',
    },
  };
}
export function getBackRecord(id, paramsData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `pa/VerifyList/${id}/Back`,
      types: [
        PUT_VERIFYLIST_BACK_REQUEST,
        PUT_VERIFYLIST_BACK_SUCCESS,
        PUT_VERIFYLIST_BACK_FAIL,
      ],
      method: 'PUT',
      params: paramsData,
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/PA/screens/ApprovePersonal/reducers/index.js
 **/